/**
 * Generate "new mail" and "new call" hyperlinks.
 * Both methods return empty <a> tag and the caller have to insert the link to the DOM.
 * mailLink(...).append(container)
 */

function normalizeContext(context) {
	if (context) {
		if (context.startsWith('?')) context = "&" + context.substring(1);
		else if (!context.startsWith('&')) context = "&" + context;
	} else context = "";
	return context;
}

/**
 * context ... can contain URL like formated string with context parameters "customer=35&person=256"
 */
export function mailLink(email, context) {
	const a = $("<a></a>");
	if (Server.hasMail) {
		a.css('cursor', 'pointer');
		context = normalizeContext(context);
		a.on("click", function(e) {
			e.preventDefault();
			openNewMailWindow('?recipient='+email+context);
		});
	} else a.attr("href", "mailto:" + email);
	return a;
}

export function mailTextLink(email, context) {
	return mailLink(email, context).text(email);
}

/**
 * cti ... bool - true if CTI (SMS) is available
 */
export function phoneLink(normalizedPhone, context) {
	const a = $("<a></a>");
	if (Server.hasCTI) {
		a.css('cursor', 'pointer');
		context = normalizeContext(context);
		a.on("click", function(e) {
			e.preventDefault();
			showActionDialog(a, context, null, normalizedPhone);
		});
	} else a.attr("href", "tel:" + normalizedPhone);
	return a;
}

export function phoneTextLink(normalizedPhone, formatedPhone, context) {
	return phoneLink(normalizedPhone, context).text(formatedPhone).css("white-space", "nowrap");
}

export function webLink(url) {
	const a = $("<a></a>");
	a.attr("href", completeUrl(url));
	return a;
}

export function webTextLink(url) {
	return webLink(url).text(url);
}

export function eaddress(ea, context) {
	if (ea.type === 1) { // e-mail
		return mailTextLink(ea.value, context);
	} else if (ea.type === 2) { // phone
		if (ea.raw) return phoneTextLink(ea.raw, ea.value, context);
		else return phoneTextLink(ea.value, ea.value, context);
	} else if (ea.type === 3) {	// web URL
		return webTextLink(ea.value);
	} else {
		return $("<span></span>").text(ea.value);
	}
}

export function completeUrl(url) {
	var lcUrl = url.toLowerCase();
	if (lcUrl.startsWith('http:') || lcUrl.startsWith('https:') || lcUrl.startsWith('ftp:') || lcUrl.startsWith('file:')
		|| lcUrl.startsWith('mailto:') || lcUrl.startsWith('tel:') || lcUrl.startsWith('//')) {
		return url;
	}
	return "http://"+url;
}
